import React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import HomeHeaderImage from "./HomeHeaderImage";
import DrawerWithForm from "./Drawer";

const Hero = ({ location, uptitle, title, slogan, cover }) => {
  return (
    <div className={` mb-20 ${location}`}>
      <div className="container">
        <div className="relative overflow-hidden rounded-3xl flex items-center justify-center">
          <div
            className={` px-4 flex justify-center items-center flex-col text-white text-center [text-shadow:_0_2px_4px_rgb(0_0_01_/_0.1)] ${
              location !== "legal" && location !== "contact"
                ? "h-[60vh]"
                : "pt-8 md:pt-10 pb-2 md:pb-4"
            }`}
          >
            {location === "zona" ? (
              <ol
                itemscope=""
                itemtype="https://schema.org/BreadcrumbList"
                className="text-amber-400 mb-2 sm:mb-1 font-semibold text-xs sm:text-sm inline-block sm:flex gap-1"
              >
                <li
                  itemprop="itemListElement"
                  itemscope=""
                  itemtype="https://schema.org/ListItem"
                  className="after:content-['/'] after:ml-1 last:after:hidden"
                >
                  <Link itemprop="item" to="/" title="Cerramientos en Madrid">
                    <span itemprop="name">Cerramientos Proyectop</span>
                  </Link>
                  <meta itemprop="position" content="1" />
                </li>
                <li
                  itemprop="itemListElement"
                  itemscope=""
                  itemtype="https://schema.org/ListItem"
                >
                  <span itemprop="name">{uptitle}</span>
                  <meta itemprop="position" content="2" />
                </li>
              </ol>
            ) : (
              <p
                aria-label="Nombre de la empresa"
                className=" text-amber-400 md:font-semibold text-sm"
              >
                {uptitle}
              </p>
            )}
            <h1
              className={`uppercase font-extrabold ${
                location === "contact"
                  ? "text-xs md:text-sm text-amber-400 tracking-wider" // <-- tus clases personalizadas para 'contact'
                  : ["page", "legal"].includes(location)
                  ? "mb-4 md:mb-6  text-2xl md:text-4xl"
                  : "mb-4 md:mb-6 md:text-lg md:tracking-wider"
              }`}
            >
              {title}
            </h1>
            {slogan && (
              <p
                aria-label="claim"
                className={`mb-4 ${
                  ["home", "zona", "contact"].includes(location)
                    ? "font-black text-4xl md:text-6xl"
                    : "text-sm md:text-base"
                }`}
                dangerouslySetInnerHTML={{ __html: slogan }}
              />
            )}
            {!["legal", "contact"].includes(location) && (
              <DrawerWithForm
                text="Empieza tu proyecto"
                buttonClasses="hover:border-amber-400 hover:bg-amber-400 hover:text-white [text-shadow:none]"
                municipioInicial={location === "zona" ? uptitle : ""}
              />
            )}
          </div>
          <div className="absolute -z-10 top-0 left-0 w-full h-full rounded-full ">
            {["home", "contact", "thank-you", "404", "legal"].includes(
              location
            ) && (
              <HomeHeaderImage
                className={`h-full w-full object-cover ${
                  ["legal", "contact"].includes(location)
                    ? "brightness-50"
                    : "brightness-75"
                }`}
              />
            )}

            {["page", "zona"].includes(location) &&
              cover?.localFile?.childImageSharp && (
                <GatsbyImage
                  image={cover.localFile.childImageSharp.gatsbyImageData}
                  alt={title}
                  placeholder="BLURRED"
                  priority
                  className=" brightness-50 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full object-cover"
                />
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
